// extracted by mini-css-extract-plugin
module.exports = {"soundControl":"Controls_soundControl__To_zs","speakerIcon":"Controls_speakerIcon__2TTwm","langCodes":"Controls_langCodes__U6zdM","langCode":"Controls_langCode__o2-iw"};